// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireFilledSvg from "@ant-design/icons-svg/es/asn/FireFilled";
import AntdIcon from '../components/AntdIcon';

var FireFilled = function FireFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireFilledSvg
  }));
};

FireFilled.displayName = 'FireFilled';
export default React.forwardRef(FireFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FireFilled.js
// module id = 1175
// module chunks = 0